export default {
  TableHeadFeature: [
    [
      {
        displayName: 'feature.header.number',
      },
      {
        displayName: 'feature.header.type',
      },
      {
        displayName: 'feature.header.username',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'feature.header.nickname',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'feature.header.edit',
        attr: {
          class: 'text-center',
        },
      },
      {
        displayName: 'feature.header.status',
        attr: {
          class: 'text-center',
        },
      },
      {
        displayName: 'Feature',
        attr: {
          class: 'text-center',
        },
      },
    ],
  ],
};
